import { FormQuestionDto } from "@green0meter/api-client";
import React from "react";
import { SortableElement } from "react-sortable-hoc";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

import { Box, Card, Stack } from "@components/base";

const SortableItem = SortableElement<{ value: FormQuestionDto }>(
  ({ value }: { value: FormQuestionDto }) => (
    <Card sx={{ zIndex: 99999, userSelect: "none" }}>
      <Stack spacing={1} direction="row" alignItems="center" p={1}>
        <DragIndicatorIcon />
        <Box flexGrow={1}>{value.name}</Box>
      </Stack>
    </Card>
  ),
);

export default SortableItem;
